export enum Type {
    admin = 'ROLE_ADMIN',
    docente = 'ROLE_DOCENTE',
    studente = 'ROLE_STUDENTE',
}